const namespace = "PERIOD_SELECTOR_"

export const CONSTANTS = {
    SET_SELECTED_PERIOD: `${namespace}SET_SELECTED_PERIOD`,
    RESET_DROPDOWN: `${namespace}RESET_DROPDOWN`,

    SET_FROM_DATE: `${namespace}SET_FROM_DATE`,
    SET_TO_DATE: `${namespace}SET_TO_DATE`
}